import { render, staticRenderFns } from "./DetalhamentoResultadosDiagnosticos.vue?vue&type=template&id=3ceb19b8&lang=pug"
import script from "./DetalhamentoResultadosDiagnosticos.vue?vue&type=script&lang=js"
export * from "./DetalhamentoResultadosDiagnosticos.vue?vue&type=script&lang=js"
import style0 from "./DetalhamentoResultadosDiagnosticos.vue?vue&type=style&index=0&id=3ceb19b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports